var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin || _vm.checkAccess('staffs'))?_c('div',[_c('report-list-page',{attrs:{"page-title":"Staff Report","page-icon":"mdi-account","descending":true,"headers":_vm.headers,"state-end-point":"staff.staffs","actions":_vm.actions,"show-component":_vm.showComponent,"item-key":"id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }